import { apiFetch } from './client';
import type { Deploy } from '$lib/types';

export const deploysApi = {
  // admin: all deploys; member: only their granted projects'.
  list: () => apiFetch<{ results: Deploy[]; count: number }>('/deploys'),
  create: (body: { project_id: number; sha?: string; target?: string; artifact?: string; by?: string }) =>
    apiFetch<Deploy>('/deploys', { method: 'POST', body: JSON.stringify(body) })
};
